import './style/entry.scss';
import './js/entry';
import './js/shared/services/UserService';

import initSearchWithConfig from '@search/main';

initSearchWithConfig();
